import { Web3Provider } from '@ethersproject/providers'
import React from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { usePublicClient, useWalletClient, WagmiProvider as WagmiProviderWagmi } from 'wagmi'
import type { Config } from 'wagmi'

const queryClient = new QueryClient()

interface WagmiProviderProps {
  config: Config
  children: React.ReactNode
}

export function PancakeWagmiProvider({ config, children }: WagmiProviderProps) {
  return (
    <WagmiProviderWagmi config={config}>
      <QueryClientProvider client={queryClient}>
        <Web3LibraryProvider>{children}</Web3LibraryProvider>
      </QueryClientProvider>
    </WagmiProviderWagmi>
  )
}

const Web3LibraryContext = React.createContext<Web3Provider | undefined>(undefined)

export const useWeb3LibraryContext = () => {
  return React.useContext(Web3LibraryContext)
}

const Web3LibraryProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const publicClient = usePublicClient()
  const { data: walletClient } = useWalletClient()

  const library = React.useMemo(() => {
    if (walletClient) {
      const provider = walletClient.transport as any
      if (provider?.request) {
        return new Web3Provider(provider)
      }
    }
    if (publicClient) {
      const transport = publicClient.transport as any
      if (transport?.request) {
        return new Web3Provider(transport)
      }
    }
    return undefined
  }, [publicClient, walletClient])

  return <Web3LibraryContext.Provider value={library}>{children}</Web3LibraryContext.Provider>
}
